import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import Styles from '../app/public/Components/Styles/StoreNotFound.module.css'

export default function PageNotFound() {

    const navigate = useNavigate()

    return (
        <div className={Styles.container}>

            <Stack className={Styles.content} justifyContent='space-evenly' alignItems='center'>
                <Typography variant='h4'>
                    Tienda no encontrada
                </Typography>
                <Typography variant='h6'>
                    Es probable que hayas utilizado un link incorrecto
                </Typography>
                <Button variant='outlined' onClick={() => navigate('/')}>
                    Ir a Tookeat
                </Button>
            </Stack>

        </div>
    )
}